import AppLayout from '../AppLayout'
import PianiDiZonaSection from './PianiDiZonaSection'

export default function PianiDiZonaPage() {
  return (
    <AppLayout>
      {({ selectedAmbito, onSelectedAmbitoChange }) => (
        <section className="telemetry-dashboard">
          <div className="telemetry-inner">
            <PianiDiZonaSection
              selectedAmbitoId={selectedAmbito}
              onSelectedAmbitoChange={onSelectedAmbitoChange}
            />
          </div>
        </section>
      )}
    </AppLayout>
  )
}
